import styled from 'styled-components';
import Colors from 'assets/Colors.js';

const footerContainer = styled.div`
  width: ${(props) => props.width || '80%'};
  margin: 0 auto;
  display: flex;
  min-height: 55px;
  height: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 15px 24px 0px 24px;
  position: relative;
  bottom: 0;
  overflow: hidden;
  font-size: 14px;
  font-style: italic;
  color: ${Colors.background_dividers};
  @media (max-width: 900px) {
    flex-direction: column-reverse;
    width: 100%;
    height: 100%;
  }
  @media (max-width: 800px) {
    position: static;
    padding-bottom: ${(props) => props.paddingBottom || '0px'};
  }
  @media (max-height: 600px) {
    height: 100%;
  }
`;

const container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  @media (max-width: 900px) {
    flex-direction: column-reverse;
  }
`;

const bar = styled.div`
  width: ${(props) => props.width || '80%'};
  margin: 0 auto;
  border-top: 0.1px solid ${Colors.background_soft};
  margin-top: 0px;
  display: none;
  @media (max-width: 900px) {
    width: 97%;
    display: block;
  }
  @media (max-width: 768px) {
    margin-top: ${(props) => props.marginTop || '0px'};
  }
`;

const rightsReserved = styled.div`
  display: flex;
  width: 50%;
  text-align: center;
  @media (max-width: 900px) {
    width: 100%;
    justify-content: center;
  }
  @media (max-width: 768px) {
    margin-bottom: 10px;
    font-size: 12px;
  }
`;
const containerlogo = styled.a`
  @media (max-width: 900px) {
    display: none;
  }
`;
const links = styled.div`
  width: 50%;
  justify-content: flex-end;
  @media (max-width: 900px) {
    justify-content: center;
    width: 100%;
  }
`;

export default {
  footerContainer,
  bar,
  rightsReserved,
  containerlogo,
  container,
  links,
};
